import * as React from 'react';

import { TextExternalLink } from '@/components/elements/Text/TextLink';

import { Dl, Text, TextLink, TextNote, TitleSmall } from '../../style';
import { ContentInnerBox } from '../style';

const CarryOver: React.FC = () => {
  return (
    <>
      <TitleSmall>キャリーオーバーについて</TitleSmall>
      <Text>
        当せん者が出なかった場合や、当せん者が出ても配当金が余った場合、次回開催に「キャリーオーバー（繰り越し）」されます。
      </Text>
      <TextNote>
        <i>※</i>
        キャリーオーバーの対象は、チャリロト・チャリロトセレクト・チャリロト5・Dokanto!7・Dokanto!4twoです。
      </TextNote>
      <Text>
        チャリロト・チャリロトセレクト・チャリロト5は、複数の競輪場がグループになり同じグループの競輪場でキャリーオーバー額を引き継いで発売します。この開催の事を「グループ開催」と呼びます。
        <br />
        競輪場のグループ、開催日程については、
        <TextLink to="/calendar">開催カレンダー</TextLink>をご確認ください。
      </Text>
      <ContentInnerBox>
        <TitleSmall>チャリロト販売停止の場合の取り扱い</TitleSmall>
        <Text>
          グループ開催移行の際、単独開催の7重勝単式「チャリロト」の発売を終了する競輪場があります。
          <br />
          一旦キャリーオーバー額がリセットされるため、最終発売日につきましては一つ外しまでを的中※として取り扱いいたします。
        </Text>
        <TextNote>
          <i>※</i>
          全的中者がいない場合に限る
        </TextNote>
        <Text>
          なお、一つ外しでも的中者がいない場合のキャリーオーバー金につきましては、施行者の収入となります。
          <br />
          （適用条文：自転車競技法施行規則第22条の2 第1項、第2項）
        </Text>
        <Dl>
          <dt>・全的中の場合</dt>
          <dd>
            現在のチャリロト同様に『払い戻し可能総額(前回からのキャリーオーバー額＋発売日の総額売上金の75%)÷的中口数』が払い戻されます。
          </dd>
          <dt>・一つ外しの場合</dt>
          <dd>
            現在7レースの全て的中が1人もいなかった場合、6レース的中者（1レースだけ外れた人）が当せんとなります。
          </dd>
        </Dl>
      </ContentInnerBox>
      <Text>
        チャリロトに関する詳細は、
        <TextExternalLink
          href="https://www.chariloto.com/statics/chariloto_group"
          target="_blank"
          rel="noreferrer"
          fontWeight="normal"
        >
          チャリロトサイト
        </TextExternalLink>
        よりご確認ください。
      </Text>
    </>
  );
};

export default CarryOver;
